import { render, staticRenderFns } from "./LoadingBackup.vue?vue&type=template&id=d653d17e"
import script from "./LoadingBackup.vue?vue&type=script&lang=js"
export * from "./LoadingBackup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports